<template>
  <Frame class="frame">
    <template v-slot:header>
      <div class="header" v-show="type == 1" @click="showStudentTree">
        <div class="left">按组织选择</div>
        <div class="right">
          <van-icon name="arrow" />
        </div>
      </div>
    </template>

    <template v-slot:body>
      <indexList
        :list="indexList"
        :check-type="checkType"
        :default-user-indexs="checkedListUserIndex"
        v-show="type == 1"
        @changeIndexList="onChangeIndexList"
      />
      <StudentTree
        :type="sourceType"
        :list="treeList"
        :check-type="checkType"
        :default-checked-list="checkedListUserIndex"
        v-if="type == 2"
        @change="onChangeStudentTree"
      />
    </template>

    <template v-slot:footer>
      <div class="footer" v-show="type == 1">
        <van-button type="primary" round block @click="okEvt">提交</van-button>
      </div>
    </template>
  </Frame>
</template>

<script>
import Frame from "@/components/frame.vue";
import indexList from "./indexList.vue";
import StudentTree from "./studentTree.vue";

import { pySegSort } from "@/utils/contact-sort.js";
import guid from "@/utils/guid.js";

import { ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

export default {
  name: "Student",
  components: {
    Frame,
    indexList,
    StudentTree,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    // 初始化初始参数
    const query = route.query;
    const sourceType = ref(query.sourceType || "S"); // S 获取学生数据 T 获取老师数据
    const resType = query.resType || "user"; // [Array] user 对象形式 userIndex 用户身份索引形式
    const checkType = ref(query.checkType || "multiple"); // single 单选 multiple
    const moduleName = query.moduleName;
    const limit = query.limit;
    const limitRange = query.limitRange;
    const defaultList = query.defaultList;

    // type 1 indexList  2 treeList
    const type = ref(1);

    const indexList = ref([]);
    const treeList = ref([]);
    const checkedListUserIndex = ref(defaultList || []);
    const checkedListUser = ref([]);

    // 获取数据
    if (sourceType.value == "S") {
      // 获取学生
      const treeAndAllUser = (params) =>
        store.dispatch("common/treeAndAllUser", params);
      const getTreeAndAllUser = async () => {
        let params = {
          isAuth: true,
        };
        let r = await treeAndAllUser(params);
        let serveList = r.data.list;
        let [userList, list] = formatUserList(serveList);
        treeList.value = list;
        indexList.value = pySegSort(userList).segs;
      };
      getTreeAndAllUser();
    } else {
      // 获取部门老师
      const allTeacherAndTree = (params) =>
        store.dispatch("common/allTeacherAndTreePost", params);
      const getAllTeacherAndTree = async () => {
        let params = {
          // isUserPresenceDepartment: false, // 是否只获取有人的部门
          userIndex: limit ? limitRange : "",
        };
        let r = await allTeacherAndTree(params);
        let serveList = [...r.data.departmentTree, ...r.data.personList];
        let [userList, list] = formatUserList(serveList);
        treeList.value = list;
        indexList.value = pySegSort(userList).segs;
      };
      getAllTeacherAndTree();
    }

    const formatUserList = (list) => {
      let userList = [];
      if (!list || !list.length) return;
      function loop(list) {
        list.forEach((item) => {
          // 添加全局唯一标识
          item._key = guid();
          if (item && item.userIndex) {
            item._type = "P";
            item.userType = sourceType.value;
            if (!userList.some((user) => user.userIndex == item.userIndex)) {
              userList.push(item);
            }
          }
          if (sourceType.value == "S") {
            if (item.studentMiniVos && item.studentMiniVos.length) {
              item.child = [...item.child, ...item.studentMiniVos];
            }
          } else {
            if (item.personList && item.personList.length) {
              item.child = [...item.child, ...item.personList];
            }
          }

          if (item.child && item.child.length) {
            loop(item.child);
          } else {
            item._isLeaf = true;
          }
        });
      }
      loop(list);
      return [userList, list];
    };

    const showStudentTree = () => {
      type.value = 2;
    };

    // 通讯录被选中人员
    const onChangeIndexList = (list) => {
      checkedListUserIndex.value = [];
      checkedListUser.value = [];

      if (list && list.length) {
        list.map((user) => {
          checkedListUserIndex.value.push(user.userIndex);
          checkedListUser.value.push(user);
        });
      }
    };

    const onChangeStudentTree = (list) => {
      checkedListUserIndex.value = [];
      checkedListUser.value = [];
      if (list && list.length) {
        list.map((user) => {
          checkedListUserIndex.value.push(user.userIndex);
          checkedListUser.value.push(user);
        });
      }
      type.value = 1;
    };

    const okEvt = () => {
      let resData = [];
      if (resType === "user") {
        resData = checkedListUser.value;
      } else {
        resData = checkedListUserIndex.value;
      }
      console.log(",,,,,",resData)
      store.commit("setPersionSelectedPage", {
        moduleName,
        data: resData,
      });
      router.go(-1);
    };

    return {
      sourceType,
      type,
      checkType,
      indexList,
      treeList,
      checkedListUserIndex,
      showStudentTree,
      onChangeIndexList,
      onChangeStudentTree,
      okEvt,
    };
  },
};
</script>

<style lang="less" scoped>
.frame {
  height: 100vh;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 54px;
    padding: 0 15px;
    color: #333;
    font-size: 15px;
    font-weight: 400;
    border-bottom: 1px solid #e5e5e5;
    background-color: #fff;
  }
}
.footer {
  box-sizing: border-box;
  padding: 6px 15px;
  border-top: 1px solid #e5e5e5;
  background-color: #fff;
}
</style>